import type { BrainstormClarifyingQuestion } from '@frontend/api-types';
import { YStack } from '../Primitives/Containers/Stacks/YStack';
import { Text } from '../Primitives/Texts/Text';

export type ClarifyingQuestionBlockProps = {
  isDisabled?: boolean;
  isOptionSelected: (label: string) => boolean;
  onOptionClick: (label: string) => void;
  question: BrainstormClarifyingQuestion;
  questionNumber: number;
};

export const ClarifyingQuestionBlock = ({
  isDisabled,
  isOptionSelected,
  onOptionClick,
  question,
  questionNumber,
}: ClarifyingQuestionBlockProps) => (
  <YStack className="gap-sm">
    <Text className="text-neutral-950" type="p-sm">
      {questionNumber}. {question.question}
    </Text>
    <YStack className="gap-xs">
      {question.options.map((opt) => {
        const isSelected = isOptionSelected(opt.label);
        return (
          <button
            aria-pressed={isSelected}
            className={`rounded-lg border px-md py-sm text-left transition-all ${
              isSelected
                ? 'border-neutral-950 bg-cream-100'
                : 'border-cream-200 hover:border-cream-300 hover:bg-cream-50'
            } ${isDisabled ? 'opacity-60 cursor-not-allowed' : ''}`}
            disabled={isDisabled}
            key={opt.label}
            onClick={() => onOptionClick(opt.label)}
            type="button"
          >
            <Text className="text-neutral-950" type="p-sm">
              {opt.label}
            </Text>
            <Text color="tertiary" type="caption">
              {opt.description}
            </Text>
          </button>
        );
      })}
    </YStack>
    {question.multiSelect ? (
      <Text color="tertiary" type="caption">
        You can select multiple
      </Text>
    ) : null}
  </YStack>
);
